import {h, render, Component} from 'preact';
import {TRIGGER_POSITIONS_MAP} from '../constants/Trigger';
import {observer} from "mobx-preact";
import {setCookie} from "../utils/Cookie";
import {DEBUG} from "../constants/Env";
import request from "../utils/Request";
import {SHOP} from "../constants/Common";


@observer
class Trigger extends Component {

    constructor(props) {
        super(props);

        this.appStore = props.appStore;
        this.campaignStore = props.campaignStore;
        this.triggerEl = null;
        if (props.isAdminComponent) {
            window.setTriggerLabel = this.campaignStore.setTriggerLabel;
            window.setTriggerCampaign = this.campaignStore.getCampaignFromJson;
            const eventTriggerLoaded = new Event('triggerLoaded');
            document.dispatchEvent(eventTriggerLoaded);
        }
    }

    componentDidMount() {
        if(!this.appStore.triggerTracked){
            request.get(`/tt_game/?shop=${SHOP}`);
            this.appStore.triggerTracked = true;
        }
        this.campaignStore.setTriggerColors(this.triggerEl)
    }

    showPopUp = () => {
        this.appStore.showPopup = true;
    };

    getTriggerPositionStyles = () => {
        if (this.campaignStore.triggerTheme === 'v3'){
            return {}
        }
        return TRIGGER_POSITIONS_MAP[this.campaignStore.triggerPosition]
    };

    hideWidget = () => {
        if (!DEBUG){
            setCookie('wheel_app_hide', 'true', this.campaignStore.hideAppExpirationDays);
        }
        this.appStore.appIsVisible = false;
    };
    getTriggerThemeClass(){
        return `kol-trigger-theme-${this.campaignStore.triggerTheme}`;
    }

    render() {
        const {triggerLabel, triggerTheme} = this.campaignStore;
        const triggerPositionStyles = this.getTriggerPositionStyles() || {};
        const triggerAnimation = this.appStore.showTriggerAnimation;
        const triggerThemeClass = this.getTriggerThemeClass();
        let additionalThemeClass = ''
        if (SHOP === 'sunber.myshopify.com' && triggerTheme === 'v3'){
            additionalThemeClass = 'kol-trigger--left'
        }

        if (this.props.isAdminComponent){
            triggerPositionStyles.position = 'absolute';
            triggerPositionStyles['white-space'] = 'nowrap';
        }

        return <div id='kol-trigger' className={`kol-contrast-calc kol-trigger ${triggerAnimation ? 'kol-trigger-animation' : ''} ${triggerThemeClass} ${additionalThemeClass}`}
                    style={triggerPositionStyles} onClick={this.showPopUp} ref={triggerEl => this.triggerEl = triggerEl}>
            <svg class="kol-trigger__icon" width="72" height="74" viewBox="0 0 72 74" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M36 7a31 31 0 1 0 0 62.001A31 31 0 0 0 36 7z" fill="var(--kol-circle-main-color)"/>
                <path opacity=".1" fill="var(--kol-sector-text-color)"
                      d="M57.22 16.78L36 38V8a30 30 0 0 1 21.22 8.78zM14.78 59.22A30.002 30.002 0 0 0 36 68V38L14.78 59.22zM66 38a30 30 0 0 1-8.78 21.22L36 38h30zM14.78 16.78A30 30 0 0 0 6 38h30L14.78 16.78z"/>
                <path filter="url(#filter0_d_305_20)" d="M36 40a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" fill="#fff"/>
                <g filter="url(#filter0_d_305_20)">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M18.222 11.393a32 32 0 1 1 35.556 53.213 32 32 0 0 1-35.556-53.213zm33.924 2.442A29.063 29.063 0 0 0 36 8.937 29.095 29.095 0 0 0 6.938 38a29.063 29.063 0 1 0 45.208-24.165z"
                          fill="#fff"/>
                </g>
                <g filter="url(#filter1_d_305_20)">
                    <path d="M36.025 2l-.05.002L35.926 2a6.015 6.015 0 0 0-4.2 1.723A5.764 5.764 0 0 0 30 7.85c0 2.468 3.07 9.125 5.975 12.15C38.905 16.975 42 10.318 42 7.85c0-.768-.155-1.529-.455-2.239-.3-.71-.74-1.354-1.295-1.898a5.986 5.986 0 0 0-1.939-1.268A6.087 6.087 0 0 0 36.025 2z"
                          fill="#fff"/>
                </g>
                <path d="M36 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8z" fill="var(--kol-circle-main-color)"/>
                <defs>
                    <filter id="filter0_d_305_20" x="0" y="2" width="72" height="72" filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset/>
                        <feGaussianBlur stdDeviation="2"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix values="0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0.25 0"/>
                        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_305_20"/>
                        <feBlend in="SourceGraphic" in2="effect1_dropShadow_305_20" result="shape"/>
                    </filter>
                    <filter id="filter1_d_305_20" x="28" y="0" width="16" height="22" filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset/>
                        <feGaussianBlur stdDeviation="1"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix values="0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0.25 0"/>
                        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_305_20"/>
                        <feBlend in="SourceGraphic" in2="effect1_dropShadow_305_20" result="shape"/>
                    </filter>
                </defs>
            </svg>
            <div className='kol-trigger__content'>
                {triggerLabel}
            </div>
            <button className="kol-trigger__close" onClick={this.hideWidget}>
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
                    <path d="M5.71 5L9.85.85a.48.48 0 0 0 0-.7.48.48 0 0 0-.7 0L5 4.29.85.15a.48.48 0 0 0-.7 0 .48.48 0 0 0 0 .7L4.29 5 .15 9.15a.48.48 0 0 0 0 .7.47.47 0 0 0 .35.15.47.47 0 0 0 .35-.15L5 5.71l4.15 4.14a.48.48 0 0 0 .7 0 .48.48 0 0 0 0-.7z"/>
                </svg>
            </button>
        </div>
    }
}

export default Trigger;
